/* Cart drawer CRO: upsell add buttons → /cart/add.js with section re-render */
(function () {
  if (window.__dtCartInit) return;
  window.__dtCartInit = true;
  function drawer() { return document.querySelector('cart-drawer'); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dt-upsell-add]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-dt-upsell-add');
    if (btn.hasAttribute('data-dt-upsell-select')) {
      var sel = btn.parentElement.querySelector('.dt-cart-feat__select');
      if (sel && sel.value) id = sel.value;
    }
    var label = btn.querySelector('.dt-cart-upsell-card__add') || btn;
    var row = btn.closest('.dt-cart-upsell-row'); if (row) row.classList.add('is-loading');
    var orig = label.textContent;
    btn.disabled = true; btn.classList.add('is-loading'); label.textContent = 'Adding…';
    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || 'add failed');
      var d = drawer();
      if (d && res.sections) {
        d.renderContents(res);
      } else {
        window.location.href = '/cart';
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      btn.disabled = false; btn.classList.remove('is-loading'); label.textContent = 'Try again';
      setTimeout(function () { label.textContent = orig; }, 2000);
    });
  });
})();

// Cart drawer discount code: apply / remove codes with /cart/update.js and re-render the drawer.
(function () {
  function root() { return Shopify && Shopify.routes ? Shopify.routes.root : '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function box() { return document.querySelector('[data-dt-discount]'); }
  function currentCodes() {
    var el = document.querySelector('[data-dt-discount-codes]');
    try { return JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { return []; }
  }
  function setBusy(on) {
    var b = document.querySelector('[data-dt-discount-apply]');
    if (b) b.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function showError(msg, code) {
    var err = document.querySelector('[data-dt-discount-error]');
    var input = document.querySelector('[data-dt-discount-input]');
    if (input && code) input.value = code;
    if (!err) return;
    var box = err.closest('details');
    if (box && msg) box.open = true;
    err.textContent = msg;
    err.hidden = !msg;
  }
  function update(codes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }
  function render(res) {
    var d = drawer();
    if (d && res && res.sections) d.renderContents(res);
    else window.location.reload();
  }
  function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }

  function apply(code) {
    code = (code || '').trim();
    if (!code) { showError('Please enter a discount code.'); return; }
    var codes = currentCodes().filter(function (c) { return !same(c, code); });
    codes.push(code);
    setBusy(true);
    update(codes).then(function (res) {
      var hit = (res.discount_codes || []).filter(function (d) { return same(d.code, code); })[0];
      if (hit && hit.applicable) { render(res); return; }
      // not valid for this cart: take it off again, keep the rest, then explain
      return update(codes.filter(function (c) { return !same(c, code); })).then(function (res2) {
        render(res2);
        setTimeout(function () { showError('“' + code + '” isn’t valid for the items in your cart.', code); }, 50);
      });
    }).catch(function () {
      showError('Something went wrong, please try again.');
    }).then(function () { setBusy(false); });
  }

  function remove(code) {
    update(currentCodes().filter(function (c) { return !same(c, code); })).then(render);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-dt-discount-apply]');
    if (a) {
      var input = document.querySelector('[data-dt-discount-input]');
      apply(input && input.value);
      return;
    }
    var r = e.target.closest('[data-dt-discount-remove]');
    if (r) remove(r.getAttribute('data-dt-discount-remove'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-dt-discount-input]')) {
      e.preventDefault();
      apply(e.target.value);
    }
  });
})();

// Cart cross-sell quick-view modal (Dogshood-style). Cards: [data-dt-xsell-open="<template id>"] in
// snippets/dt-cart-cross-sell.liquid. The modal lives on <body> so cart-drawer re-renders don't remove it.
(function () {
  if (window.__dtXsellInit) return;
  window.__dtXsellInit = true;
  var modal = null;
  var CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true"><circle cx="14" cy="14" r="13.1" stroke="black" stroke-width="1.75"/><path d="M9.7 9.7l8.6 8.6M18.3 9.7l-8.6 8.6" stroke="black" stroke-width="1.75" stroke-linecap="round"/></svg>';
  function root() { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; }
  function build() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'c-pdp-modal';
    modal.hidden = true;
    modal.innerHTML = '<div class="c-pdp-modal__overlay" data-dt-xsell-close></div>' +
      '<div class="c-pdp-modal__panel" role="dialog" aria-modal="true" aria-label="Product details">' +
      '<button type="button" class="c-pdp-modal__close" data-dt-xsell-close aria-label="Close">' + CLOSE_SVG + '</button>' +
      '<div class="c-pdp-modal__body" data-dt-xsell-body></div></div>';
    document.body.appendChild(modal);
    return modal;
  }
  function open(id) {
    var tpl = document.getElementById(id);
    if (!tpl) return;
    var m = build();
    var body = m.querySelector('[data-dt-xsell-body]');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    try { m._variants = JSON.parse(body.querySelector('[data-dt-xsell-variants]').textContent); } catch (e) { m._variants = []; }
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    var close = m.querySelector('.c-pdp-modal__close');
    if (close) close.focus();
  }
  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    setTimeout(function () { modal.hidden = true; modal.querySelector('[data-dt-xsell-body]').innerHTML = ''; }, 200);
  }
  function select(btn) {
    var group = btn.closest('[data-dt-xsell-option]');
    group.querySelectorAll('[data-dt-xsell-value]').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
    var label = group.querySelector('[data-dt-xsell-selected]');
    if (label) label.textContent = btn.getAttribute('data-dt-xsell-value');
    var chosen = [];
    modal.querySelectorAll('[data-dt-xsell-option]').forEach(function (g) {
      var s = g.querySelector('.is-selected');
      chosen[parseInt(g.getAttribute('data-dt-xsell-option'), 10)] = s ? s.getAttribute('data-dt-xsell-value') : null;
    });
    var v = (modal._variants || []).filter(function (x) {
      return x.options.every(function (o, i) { return chosen[i] == null || chosen[i] === o; });
    })[0];
    var add = modal.querySelector('[data-dt-xsell-add]');
    if (!v) { add.disabled = true; add.textContent = 'Unavailable'; return; }
    add.setAttribute('data-dt-xsell-add', v.id);
    add.disabled = !v.available;
    add.textContent = v.available ? 'Add To Cart' : 'Sold out';
    modal.querySelector('[data-dt-xsell-now]').textContent = v.price;
    var was = modal.querySelector('[data-dt-xsell-was]');
    var off = modal.querySelector('[data-dt-xsell-off]');
    was.hidden = !v.compare; if (v.compare) was.textContent = v.compare;
    off.hidden = !v.off; if (v.off) off.textContent = '-' + v.off + '%';
    var img = modal.querySelector('.c-pdp-modal__media img');
    if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
  }
  function addToCart(btn) {
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-dt-xsell-add'), 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || 'add failed');
      var d = document.querySelector('cart-drawer');
      if (d && res.sections) d.renderContents(res); else window.location.href = root() + 'cart';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      close();
    }).catch(function () {
      btn.textContent = 'Try again';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
    });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-dt-xsell-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-dt-xsell-open')); return; }
    if (!modal || modal.hidden) return;
    if (e.target.closest('[data-dt-xsell-close]')) { close(); return; }
    var v = e.target.closest('[data-dt-xsell-value]');
    if (v && modal.contains(v)) { select(v); return; }
    var a = e.target.closest('[data-dt-xsell-add]');
    if (a && modal.contains(a) && !a.disabled) addToCart(a);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
